<script>
  import { translator, userStore } from "../../store";
  import { DataTable, Modal, Button } from "../../components/index.svelte";
  import {
    deleteReservation,
    getPropertyReservations,
  } from "../../helpers/apiHelpers/index.svelte";
  import { onMount } from "svelte";
  import { formatDate, toast, checkIfAdmin } from "../../helpers/utils.svelte";
  import { navigate } from "svelte-navigator";
  export let propertyID;
  export let openRatingModal;
  export let onUpdate;
  function onEditReservation(reservation) {
    navigate(
      `/property-management/properties/${propertyID}/reservations/${reservation.id}/edit`
    );
  }
  function onNewReservation(reservation) {
    navigate(`/property-management/properties/${propertyID}/reservations/new`);
  }

  let propertyReservations = [];
  let toggleDeleteModal;
  let reservationToDelete;
  let isAdmin = checkIfAdmin($userStore?.user?.user_type)

  export async function initializeReservations() {
    propertyReservations = await getPropertyReservations(propertyID);
    if (!propertyReservations) {
      propertyReservations = [];
    }
  }
  function onDelete(row) {
    reservationToDelete = row;
    toggleDeleteModal();
  }
  async function onDeleteReservation(reservationID) {
    try {
      await deleteReservation(reservationID);
      await initializeReservations();
      await handleUpdate();
      toast.success(
        translator("Başarılı"),
        translator('"__GUESTNAME__" kişisinin rezervasyon bilgileri silindi', {
          __GUESTNAME__: `${reservationToDelete.guest_name}`,
        })
      );
      reservationToDelete = null;
      toggleDeleteModal();
    } catch (err) {
      toast.error(
        translator("Hata"),
        translator(
          err.getResponseMessage ? err.getResponseMessage() : err.message
        )
      );
    }
  }
  function handleUpdate() {
    if (typeof onUpdate === "function") {
      onUpdate();
    }
  }
  onMount(async () => {
    await initializeReservations();
  });
</script>

<DataTable
  tableID={`reservationTable_${propertyID}`}
  title={translator("Rezervasyonlar")}
  onAddClick={isAdmin ? onNewReservation : null}
  addText={isAdmin ? translator("Yeni Rezervasyon") : null}
  eventHandlers={{
    onRatingClick: openRatingModal,
    onEdit: isAdmin ? onEditReservation : null,
    onDelete: isAdmin ? onDelete : null,
  }}
  columns={[
    {
      data: "guest_name",
      title: translator("Misafir Adı"),
      responsivePriority: 10000,
    },
    {
      data: "check_in",
      title: translator("Check In"),
      responsivePriority: 10000,
    },
    {
      data: "check_out",
      title: translator("Check Out"),
      responsivePriority: 10000,
    },
    {
      data: "night_count",
      title: translator("Gece Sayısı")
    },
    /* { data: "adult_count", title: translator("Yetişkin Sayısı") }, */
    {
      data: "nightly_earning",
      responsivePriority: 10000,
      title: translator("Günlük Kazanç"),
      render: (text) => {
        return `${text} ₺`;
      },
    },
    {
      data: "earning",
      responsivePriority: 10000,
      title: translator("Toplam Kazanç"),
      render: (text) => {
        return `${text} ₺`;
      },
    },
  ]}
  pageLength={10}
  searching={false}
  lengthSelect={false}
  defaultOrderConfig={[1, 'desc']}
  dataSource={propertyReservations}
/>

<Modal
  bind:toggle={toggleDeleteModal}
  title={translator("Dikkat!")}
  onClose={() => {
    reservationToDelete = null;
  }}
>
  <div slot="modal-body">
    {translator(
      '"__GUESTNAME__" kişisinin rezervasyonunu kalıcı olarak silmek istediğinize emin misiniz?',
      {
        __GUESTNAME__: `${reservationToDelete.guest_name}`,
      }
    )}
  </div>
  <div slot="modal-footer">
    <Button
      size="sm"
      onClick={() => onDeleteReservation(reservationToDelete.id)}
    >
      {translator("Sil")}
    </Button>
    <Button size="sm" onClick={toggleDeleteModal} colorCls="btn-dark">
      {translator("Vazgeç")}
    </Button>
  </div>
</Modal>
